import { IPatient } from "../models/Patient"
import { apiHelper } from "./core"
import { apiHelperCS } from "./core"
import { store } from "../../store"
import toastAction from "core/store/actions/toastAction"

const { dispatch } = store

const userServiceBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
const clinicalServiceBaseUrl =
  process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL
const masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL
const resourceServiceBaseUrl =
  process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL
const reportingServiceBaseUrl = process.env.REACT_APP_REPORTING_BASE_URL

const getPatientDetail = (patientId: string): Promise<IPatient> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/patients/${patientId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getPatientDetailMRD = (
  patientId: string,
  mrdId: string
): Promise<IPatient> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/patients/${patientId}?mrdRequestId=${mrdId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getConsultantById = (centerId: string): Promise<IPatient> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/staff/consultants/${centerId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllRMO = (centerId: string): Promise<IPatient> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/staff?primaryRole=RMO&centerId=${centerId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllStaff = (staffType: string): Promise<IPatient> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/staff/?staffType=${staffType}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const getallPatientDetail = (query: string): Promise<any> => {
  let url = query ? `patients${query}` : `patients`

  return apiHelper
    .get(`${userServiceBaseUrl}/${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

// const sendOtpToVerifyNumber = (phonenumber: string): Promise<any> => {
//   var data = {
//     phonenumer: ,
//   }
//   console.log(phonenumber)
//   return apiHelper
//     .post(`${userServiceBaseUrl}/patients/otp`, phonenumber)
//     .then((res) => {
//       console.log(res, "apires")
//       return res
//     })
//     .catch((err) => Promise.reject(err))
// }

const sendOtpToVerifyNumber = (data1: any): Promise<any> => {
  var data = {
    phoneNumber: data1,
  }
  console.log(data, "datas")
  return apiHelper
    .post(`${userServiceBaseUrl}/patients/otp`, data)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const VerifyOtp = (data1: any, data2: any): Promise<any> => {
  var data = {
    mobileNumber: data1,
    otp: data2,
  }
  console.log(data, "datas")
  return apiHelper
    .post(`${userServiceBaseUrl}/patients/verify`, data)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const sendOtpToVerifyStaffNumber = (data1: any): Promise<any> => {
  var data = {
    phoneNumber: data1,
  }
  console.log(data, "datas2")
  return apiHelper
    .post(`${userServiceBaseUrl}/staff/otp`, data)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const VerifyStaffOtp = (data1: any, data2: any): Promise<any> => {
  var data = {
    mobileNumber: data1,
    otp: data2,
  }
  console.log(data, "datas")
  return apiHelper
    .post(`${userServiceBaseUrl}/staff/verify-phone`, data)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getallPatientFollowUp = (centerId: string): Promise<any> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/patients/follow-up?centerId=${centerId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const editPatientFollowUp = (
  patientId: string,
  status: string
): Promise<any> => {
  return apiHelper

    .patch(
      `${userServiceBaseUrl}/patients/follow-up/${patientId}?status=${status}`
    )
    .then((response) => {
      console.log(response)
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllConsultants = (query: string): Promise<any> => {
  let url = query ? `/staff${query}` : "/staff/consultants"

  return apiHelper
    .get(`${userServiceBaseUrl}${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllStaffs = (query: string): Promise<any> => {
  let url = query ? `/staff${query}` : "/staff"

  return apiHelper
    .get(`${userServiceBaseUrl}${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllTestRMO = (data: any): Promise<any> => {
  let url = ""
  const keys = Object.keys(data)
  if (keys?.includes("patientId")) {
    url = `${clinicalServiceBaseUrl}/test-results?patientId=${data?.patientId}`
  } else if (keys?.includes("appointmentId")) {
    url = `${clinicalServiceBaseUrl}/test-results?appointmentId=${data?.appointmentId}`
  }
  return apiHelper
    .get(`${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const addTest = (values: any, id: any): Promise<any> => {
  console.log(values)
  return apiHelper
    .put(`${clinicalServiceBaseUrl}/test-results/${id}`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getSmartSummaryDetails = (patientId: string): Promise<any> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/patients/${patientId}/smart-summary`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getServiceBasedOnCategory = (
  category: string,
  centerId?: any
): Promise<any> => {
  return apiHelper
    .get(
      `${masterServiceBaseUrl}/services?appointmentType=${category}${
        centerId ? `&centerId=${centerId}` : ""
      }`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const addNewPatient = (patientInfo: any): Promise<any> => {
  const id = patientInfo.id

  if (patientInfo?.id) {
    delete patientInfo.id
    delete patientInfo.documents
    delete patientInfo.advancePayment
    return apiHelper
      .put(`${userServiceBaseUrl}/patients/${id}`, patientInfo)
      .then((res) => {
        return res?.data
      })
      .catch((err) => Promise.reject(err))
  } else {
    return apiHelper
      .post(userServiceBaseUrl + "/patients", patientInfo)
      .then((res) => {
        return res?.data
      })
      .catch((err) => Promise.reject(err))
  }
}

const updateNewPatient = (patientInfo: any): Promise<any> => {
  const id = patientInfo.id
  if (patientInfo?.id) {
    delete patientInfo.id
    delete patientInfo.documents
    delete patientInfo.advancePayment
    delete patientInfo.totalAdvancePayment
    delete patientInfo.securityDeposit
    delete patientInfo.totalPendingAmount
    delete patientInfo.totalPendingInvoices
    delete patientInfo.refunds
    delete patientInfo.isEditedAlready
    delete patientInfo.oldDocuments
    return apiHelper
      .put(`${userServiceBaseUrl}/patients/${id}`, patientInfo)
      .then((res) => {
        return res?.data
      })
      .catch((err) => Promise.reject(err))
  } else {
    return apiHelper
      .post(userServiceBaseUrl + "/patients", patientInfo)
      .then((res) => {
        return res?.data
      })
      .catch((err) => Promise.reject(err))
  }
}

const mergePatient = (body: any): Promise<any> => {
  return apiHelper

    .put(`${userServiceBaseUrl}/patients/merge`, body)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const selfAssesment = (medicalRecordId: any, body: any): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/self-assessment/${medicalRecordId}`,
      body
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getPatientsByCompletenessStatus = (): Promise<any> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/patients?isDocumentUpToDate=true`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getSmartSummaryData = (id: any): Promise<any> => {
  return apiHelper.get(userServiceBaseUrl + `/patients/${id}/smart-summary`)
}

const addInvoiceLink = (data1: any, data2: number): Promise<any> => {
  return apiHelper
    .post(
      `${resourceServiceBaseUrl}/invoices/send-payment-link?invoiceId=${data1}&amount=${data2}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const generatepaymentUrl = (): Promise<any> => {
  const params = new URLSearchParams(window.location.search)
  const token = params.get("token")
  return apiHelper
    .post(
      `${resourceServiceBaseUrl}/invoices/generate-payment-url?encryptedToken=${token}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const checkPaymentInvoices = (data: any): Promise<any> => {
  return apiHelper
    .post(`${resourceServiceBaseUrl}/invoices/check-payment-status`, data)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const downloadHistoricalDocuments = (
  patientId: any,
  category: any
): Promise<any> => {
  return apiHelper
    .post(
      `${userServiceBaseUrl}/patients/historical-data-download-generate?patientId=${patientId}&category=${category}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getHistoricalDocumentsUrl = (
  patientId: any,
  category: any
): Promise<any> => {
  return apiHelper
    .get(
      `${userServiceBaseUrl}/patients/historical-data-download?patientId=${patientId}&category=${category}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getReportData = (
  reportName: any,
  skipLoader: any = false
): Promise<any> => {
  return apiHelperCS
    .get(
      `${reportingServiceBaseUrl}/report/getStatus?reportName=${reportName}`,
      { params: { skipLoader } }
    )
    .then((res: any) => {
      if (res?.data?.status === "FAILED") {
         dispatch(
           toastAction.updateToastTrue(
             "Failed to download Report, Please try again",
             "error"
           )
         )
      }
      return res?.data
    })
    .catch((err: any) => {
      Promise.reject(err)
      dispatch(
        toastAction.updateToastTrue(
          "Failed to download Report, Please try again",
          "error"
        )
      )
    })
}

export {
  getPatientDetail,
  getPatientDetailMRD,
  getallPatientDetail,
  getAllConsultants,
  getAllTestRMO,
  addTest,
  getallPatientFollowUp,
  editPatientFollowUp,
  getSmartSummaryDetails,
  getServiceBasedOnCategory,
  addNewPatient,
  getPatientsByCompletenessStatus,
  getAllStaffs,
  getSmartSummaryData,
  mergePatient,
  updateNewPatient,
  sendOtpToVerifyNumber,
  VerifyOtp,
  selfAssesment,
  sendOtpToVerifyStaffNumber,
  VerifyStaffOtp,
  addInvoiceLink,
  generatepaymentUrl,
  checkPaymentInvoices,
  getConsultantById,
  getAllStaff,
  getAllRMO,
  downloadHistoricalDocuments,
  getHistoricalDocumentsUrl,
  getReportData,
}
